import { useCallback, useState } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { kickoffMachineryEPlanUpload } from '../lib/kickoffMachineryEPlanUpload'

export function useMachineryEPlanUpload({
  productId,
  complianceId,
}: {
  productId: string
  complianceId: string
}) {
  const queryClient = useQueryClient()
  const { t } = useTranslation('machineryDirectiveCompliance')
  const [uploadingSourceIds, setUploadingSourceIds] = useState<Set<string>>(
    () => new Set()
  )

  const handleFileSelect = useCallback(
    async (file: File) => {
      await kickoffMachineryEPlanUpload({
        productId,
        complianceId,
        file,
        queryClient,
        translate: t,
        tracking: {
          onSourceAdded: (sourceId) => {
            setUploadingSourceIds((previous) => new Set(previous).add(sourceId))
          },
          onSourceFinished: (sourceId) => {
            setUploadingSourceIds((previous) => {
              const next = new Set(previous)
              next.delete(sourceId)
              return next
            })
          },
        },
      })
    },
    [productId, complianceId, queryClient, t]
  )

  return {
    handleFileSelect,
    uploadingSourceIds,
  }
}
